import React, { useState } from 'react'
import './IncluirCaixa.scss'
import { Grid, Form, Button, Header, Divider, Segment, Icon, Select } from 'semantic-ui-react'

export default function IncluirCaixa() {

    const [form,] = useState({
        numero: '',
        nome: '',
        data: '',
        turno: ''
    })

    function handleChange(event, props) {
        
    }

    const genderOptions = [
        { key: 'a', text: '1º', value: '1' },
        { key: 'b', text: '2º', value: '2' },
        { key: 'c', text: '3º', value: '3' },
        { key: 'd', text: '4º', value: '4' },
        { key: 'e', text: '5º', value: '5' },
        { key: 'f', text: '6º', value: '6' },
    ]

    return (
        <div id='incluir-caixa'>
            <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
                <Grid.Column textAlign='left' style={{ maxWidth: 400 }}>
                    <Segment raised>
                        <Header>
                            Incluir Caixa
                        <Header.Subheader>
                                Último caixa fechado: 12/11/2019 - 3° turno
                        </Header.Subheader>
                        </Header>
                        <Divider />
                        <Form size='tiny'>
                            <Form.Field>
                                <label>N° Controle</label>
                                <input value={form.numero} onChange={handleChange} />
                            </Form.Field>
                            <Form.Field>
                                <label>Nome do Caixa</label>
                                <input value={form.nome} onChange={handleChange} />
                            </Form.Field>
                            <Form.Group widths='equal'>
                                <Form.Field>
                                    <label>Data do Caixa</label>
                                    <input value={form.data} placeholder='__/__/____' onChange={handleChange} />
                                </Form.Field>
                                <Form.Field
                                    control={Select}
                                    options={genderOptions}
                                    label={{ children: 'Turno', htmlFor: 'form-select-control-gender' }}
                                    search
                                    searchInput={{ id: 'form-select-control-gender' }}
                                    onChange={handleChange} 
                                />
                            </Form.Group>

                            <Divider clearing />
                            <Button size='small' labelPosition='left' icon type='submit' primary>
                                <Icon name='arrow right' />
                                Enviar
                            </Button>
                        </Form>
                    </Segment>
                </Grid.Column>
            </Grid>
        </div>
    )
}